import { BusinessUnitShortType } from 'src/@types'
import { gaEvent, getBusinessUnitDescribed } from 'src/utils'

/**
 * Parâmetro para {@link chargeInputEvent.success}
 */
export type ChargeInputEvent = BusinessUnitShortType & {
  type: string
}

/**
 * Parâmetro para {@link chargeInputEvent.error}
 */
export type ChargeInputEventError = BusinessUnitShortType & {
  type: string
  error?: string | number
}

const baseEvent = ({ businessUnit, type }: ChargeInputEvent) => ({
  event: 'ga-event',
  'event-action': 'callback:valor',
  'event-category': `pagamentos-sellout:${getBusinessUnitDescribed(businessUnit)}:pix-${type}`,
})

/**
 * @deprecated Esse evento não é mais utilizado e será removido em breve, por favor, use {@link newChargeInputEvent}.
 * [TARGET]: Registrar evento de sucesso ou erro de um valor válido preenchido pelo usuário
 *
 * [CONTEXTO]: Na geração de cobrança, precisamos identificar se o usuário preencheu um valor válido ou inválido para entender o comportamento.
 *
 * [REGRAS]: n/a
 *
 */
export const chargeInputEvent = {
  success: ({ businessUnit, type }: ChargeInputEvent) => {
    const successEvent = {
      ...baseEvent({ businessUnit, type }),
      'event-label': 'sucesso',
    }
    gaEvent(successEvent)
  },

  error: ({ businessUnit, type, error = 'generic' }: ChargeInputEventError) => {
    const errorEvent = {
      ...baseEvent({ businessUnit, type }),
      'event-label': `erro:${error}`,
    }
    gaEvent(errorEvent)
  },
}
